<app-anlage-api-list
  [actions]="actions"
  [entryClickCommand]="entryClickCommand"
  filterStorageKey="InfoportalAnlageListFilter"
></app-anlage-api-list>
